import { cssInterop } from 'react-native-css-interop';
import { 
    View, 
    Text, 
    Pressable as RNPressable, 
    TextInput as RNTextInput, 
    ScrollView as RNScrollView 
} from 'react-native-web';

/**
 * MASTER PLAN: UNIVERSAL PRIMITIVES (v4)
 * Powered by react-native-css-interop for true cross-platform SoC.
 */

// 1. Types for Universal Support
export interface BoxProps extends React.ComponentProps<typeof View> {
    className?: string;
}

export interface TypographyProps extends React.ComponentProps<typeof Text> {
    className?: string;
}

export interface PressableProps extends React.ComponentProps<typeof RNPressable> {
    className?: string;
}

export interface ScrollBoxProps extends React.ComponentProps<typeof RNScrollView> {
    className?: string;
}

// 2. Interop Mappings
cssInterop(View, { className: 'style' });
cssInterop(Text, { className: 'style' });
cssInterop(RNPressable, { className: 'style' });
cssInterop(RNTextInput, { className: 'style' });
cssInterop(RNScrollView, { className: 'style' });

// 3. Exported Universal Building Blocks (Typed)
export const Box = View as React.FC<BoxProps>;
export const ScrollBox = RNScrollView as React.FC<ScrollBoxProps>;
export const Typography = Text as React.FC<TypographyProps>;
export const Pressable = RNPressable as React.FC<PressableProps>;
export const Input = RNTextInput;

/**
 * Architectural Note:
 * Feature components remain 100% agnostic. On Web, these resolve to
 * optimized DIVs and SPANs via react-native-web + CSS Interop.
 * On Native, we simply point this file to standard 'react-native'.
 */
